import styled, { css } from 'styled-components';
import {
  useNotificationHandlerActions,
  useNotificationHandlerView,
} from '@paradigm/features/src/unified-rfqs/ui/notifications/notifications-handler-context';
import { useUnifiedRfqsService } from '@paradigm/features/src/unified-rfqs/contexts/unified-rfqs';
import { useRfqFiltersValue } from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/filter-provider';

import ConfirmButton from './ConfirmButton';

export default function PausedNotificationsToast() {
  const { fetcher } = useUnifiedRfqsService();
  const { isNotificationPaused, newRfqCount } = useNotificationHandlerView();
  const { resetNewRfqCount, resetStoredNotifications, resumeNotifications } =
    useNotificationHandlerActions();
  const {
    state: { productCodes, strategyCodes },
  } = useRfqFiltersValue();

  const rfqsText =
    newRfqCount > 1
      ? `${newRfqCount} New Markets Available`
      : '1 New Market Available';

  const refreshTable = () => {
    resetNewRfqCount();
    resetStoredNotifications();
    resumeNotifications();

    fetcher.fetchLatest({ productCodes, strategyCodes }, () => null);
  };

  return (
    <NotificationToast
      newRfqCount={newRfqCount}
      isNotificationPaused={isNotificationPaused}
    >
      {rfqsText}
      <ConfirmButton onClick={refreshTable}>Refresh</ConfirmButton>
    </NotificationToast>
  );
}

const NotificationToast = styled.div<{
  newRfqCount: number;
  isNotificationPaused: boolean;
}>`
  background-color: black;
  border-radius: 15px;
  color: white;
  padding: 0px 14px;
  font-size: 13px;
  height: 30px;
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.5);
  transition: visibility 0s, opacity 0.5s ease;
  visibility: hidden;
  opacity: 0;

  ${({ isNotificationPaused, newRfqCount }) =>
    isNotificationPaused &&
    newRfqCount > 0 &&
    css`
      visibility: visible;
      opacity: 1;
    `}
`;
